<template>
  <div>  
    <div class="my-favourites-widget">
      <h2 class="title">My Favourites</h2>
      <span v-if="containerLoading" class="container-spinner"></span>
      <div v-else class="favourites-container">
        <div id="noFavourites" v-if="myFavourites.length === 0">
          <img src="@/assets/Myfavourites_empty_star.svg" class="empty-favourite-star">
          <p class="noFavourite-msg-title">No links have been added to My Favourites</p>
          <p>Please add links to My Favourites by clicking the star next to the link's name.</p>
        </div>
        <div class="favorite-row" id="favourite-row" v-else>
          <div v-for="myFavourite in myFavourites" :key="myFavourite.url" class="myFavourite-card">
            <a class="myFavourite-url" :href="myFavourite.url" target="_blank">
              <div class="myfavorite-card-content">
                <h4 class="myFavourite-title">{{ myFavourite.label }}</h4>
                <div class="myFavourite-arrow-container">
                  <img src="@/assets/Favourite_arrow.svg" class="myFavourite-arrow">
                </div>  
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  
    <!-- Debug -->  
    <!-- <button id="hidemyfavourites">Toggle debug info</button>
    <div id="debuginfo2">  
      <p>API Response below</p>
      <pre>{{ apiResponse }}</pre>
    </div>   -->
  </div>  
</template>  

<script setup>
import { ref, onMounted, onUnmounted } from 'vue';
import { queryDataverseFetchXml } from '@/functions/Dataverse';
import eventBus from '@/functions/eventBus';

// Local state variable to store API response
const apiResponse = ref('');
const myFavourites = ref([]);
const containerLoading = ref(false); // New state for container loading

// Function to fetch user favourites
const fetchUserFavourites = async () => {
  try {
    containerLoading.value = true; // Set container loading to true
    const tableName = 'sdportal_userfavourites';
    const result = await queryDataverseFetchXml(tableName);

    apiResponse.value = result;

    myFavourites.value = apiResponse.value.value.map(item => {
      const attributes = item;

      const sequence = attributes.sdportal_sequence;
      const url = attributes['sdportal_portallink2.sdportal_url'];
      const label = attributes['sdportal_portallink2.sdportal_label'];

      return { sequence, url, label };
    }).sort((a, b) => a.sequence - b.sequence).slice(0, 5);
  } catch{
    // console.log('Not fetching user favourites:', error);
    apiResponse.value = 'An error occurred while fetching user favourites.';
  } finally {
    containerLoading.value = false; // Set container loading to false
  }
};

// Event handler for favouriteAdded event
const onFavouriteAdded = (event) => {
  const newFavourite = event.detail;
  // Check if the favourite already exists in the myFavourites array
  const exists = myFavourites.value.some(fav => fav.url === newFavourite.url);
  if (!exists) {
    // Add the new favourite to the myFavourites array
    myFavourites.value.push({
      sequence: myFavourites.value.length + 1,
      url: newFavourite.url,
      label: newFavourite.label
    });
  }
};

// Event handler for favouriteRemoved event
const onFavouriteRemoved = (event) => {
  const removedFavourite = event.detail;
  // Remove the favourite from the myFavourites array
  myFavourites.value = myFavourites.value.filter(fav => fav.url !== removedFavourite.url);
};

onMounted(() => {
    fetchUserFavourites();

  // Listen for the favouriteAdded event
  eventBus.value.addEventListener('favouriteAdded', onFavouriteAdded);
  eventBus.value.addEventListener('favouriteRemoved', onFavouriteRemoved);

  // const hideButton = document.getElementById('hidemyfavourites');
  // hideButton.addEventListener('click', function() {
  //   const debuginfo2 = document.getElementById('debuginfo2');
  //   if (debuginfo2.style.display === 'none') {
  //     debuginfo2.style.display = 'block';
  //   } else {
  //     debuginfo2.style.display = 'none';
  //   }
  // });
  // hideButton.style.display = 'block';
});

onUnmounted(() => {
  // Remove the event listener when the component is unmounted
  eventBus.value.removeEventListener('favouriteAdded', onFavouriteAdded);
});
</script>

<style scoped>
.container-spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-left-color: #000;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  animation: spin 1s linear infinite;
  display: block;
  margin: 20px auto;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

  /* hide the hide button */
  #hidemyfavourites {
    background-color: white;
  }
  #debuginfo2 {
    display: none;
  }
  html,
body,
p,
.p,
.page_section p,
.section-diagonal-left p,
.section-diagonal-right p,
footer .footer-bottom p,
select, option, label, span, button {
  font-size: 14px;
  font-family: 'Source Sans 3', 'Microsoft YaHei', 'Microsoft JhengHei', "Glyphicons Halflings", sans-serif !important;
  font-weight: 400;
}

h1, h2, h3, h4, h5, h6 {
  font-family: 'Source Sans 3', 'Microsoft YaHei', 'Microsoft JhengHei', sans-serif !important;
  font-weight: 400;
}

a {
  text-decoration: none;
  color: black;
}

.my-favourites-widget {
  padding: 1rem;
}

.myfavorite-card-content {
  background-color: #f3f8f5;
  padding: 15px;
  height: 100%;
  min-height: 65px;
  display: flex;
  justify-content: space-between;
}

.myFavourite-title {
  text-decoration: none;
  color: black;
  padding: 0;
  margin: 0 !important;
  overflow: hidden;
  /* how to make elipsis work */
  text-overflow: ellipsis;
}

.myFavourite-arrow-container {
  display: flex;
  align-items: flex-end;
}

.myFavourite-arrow {
  height: 15px;
}

.title {
  font-weight: 600;
}

.favorite-row {
  display: flex;
}

.myFavourite-card {
  max-width: 100%;
  width: 15%;
  padding: 0 10px;
}

#noFavourites {
  display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    color: black;
}

.noFavourite-msg-title {
  font-weight: 600;
}

.favourites-container {
  padding-top: 1rem;
}
</style>